  // Replace 'https://a.klaviyo.com/api/v1/catalog/subscribe' with the actual endpoint URL
  const klaviyoSubscribeEndpoint = 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';
  const form = document.getElementById('back-in-stock-form');

  if (form) {
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    const formData = new FormData(form);

    fetch(klaviyoSubscribeEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams(formData).toString(),
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle the API response here (success or error)
        document.getElementById('bis-form').style.display = "none"
        document.getElementById('bis-success').style.display = "block"
      })
      .catch((error) => {
        // Handle any errors that occur during the API call
        console.error("Error Message: ", error);
      });
  });
}